import { evaluateGates, type GateThresholds } from '../capture/gates';
import type { GateMetrics } from '../fsm/machine';

/**
 * La riga che il recorder scrive dopo uno scatto. Dice SUBITO se la foto sarebbe stata rifiutata dai controlli del prodotto (mosso, scuro,
 * bruciato, riflessi): in Fase 0 si registra comunque (servono anche i casi difficili), ma chi scatta sa se rifarla senza aspettare l'export.
 */
export function shotSummary(id: string, sizeBytes: number, widthPx: number, heightPx: number, gates: GateMetrics, thresholds: GateThresholds): string {
  const verdict = evaluateGates(gates, thresholds);
  const base = `${id}: ${(sizeBytes / 1024).toFixed(0)} kB, ${widthPx}×${heightPx}, nitidezza ${gates.blurVariance.toFixed(0)}`;
  return verdict ? `${base} — DA RIFARE: ${verdict.hint}` : `${base} — ok`;
}

/** Il caso registrato per ultimo (per data di salvataggio), o null: è quello che «Annulla l'ultimo caso» cancella. */
export function newestCase<T extends { savedAtUtc: string }>(cases: readonly T[]): T | null {
  let newest: T | null = null;
  for (const c of cases) {
    if (newest === null || c.savedAtUtc > newest.savedAtUtc) newest = c;
  }
  return newest;
}
